import type { Theme } from "@mui/material/styles";
import type {} from "@mui/material/themeCssVarsAugmentation";

import { extendTheme } from "@mui/material/styles";

import {
  MuiBackdrop,
  MuiButton,
  MuiCard,
  MuiCardHeader,
  MuiCheckbox,
  MuiFormControlLabel,
  MuiLink,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiRadio,
  MuiTableCell,
} from "../settings/components";
import { customShadows } from "../settings/customShadow";
import { colorSchemes } from "../settings/palette";
import { shadows } from "../settings/shadows";
import { typography } from "../settings/typography";

export function createTheme(): Theme {
  const initialTheme = {
    colorSchemes,
    components: {
      MuiAutocomplete: {
        defaultProps: {
          slotProps: {
            paper: {
              elevation: 20,
            },
          },
        },
      },
      MuiBackdrop,
      MuiButton,
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiCard,
      MuiCardHeader,
      MuiCheckbox,
      MuiFormControlLabel,
      MuiLink,
      MuiMenuItem,
      MuiOutlinedInput,
      MuiPaper,
      MuiRadio,
      MuiTableCell,
    },
    cssVariables: true,
    cssVarPrefix: "",
    customShadows: customShadows(),
    shadows: shadows(),
    shape: { borderRadius: 8 },
    shouldSkipGeneratingVar,
    typography,
  };

  const theme = extendTheme(initialTheme);

  return theme;
}

function shouldSkipGeneratingVar(keys: string[]): boolean {
  const skipGlobalKeys = [
    "mixins",
    "overlays",
    "direction",
    "typography",
    "breakpoints",
    "transitions",
    "cssVarPrefix",
    "unstable_sxConfig",
  ];

  const skipPaletteKeys: Record<string, string[]> = {
    global: ["tonalOffset", "dividerChannel", "contrastThreshold"],
    grey: ["A100", "A200", "A400", "A700"],
    text: ["icon"],
  };

  const isPaletteKey = keys[0] === "palette";

  if (isPaletteKey) {
    const paletteType = keys[1];
    const skipKeys = skipPaletteKeys[paletteType] || skipPaletteKeys.global;

    return keys.some((key) => skipKeys?.includes(key));
  }

  return keys.some((key) => skipGlobalKeys?.includes(key));
}
